import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMenu, FiX } = FiIcons;

const Navigation = ({ onBookPilot }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
   // { label: 'Product', href: '#features' },
    { label: 'How it works', href: '/#how-it-works' },
    { label: 'Features', href: '/#features' },
    { label: 'For Recruiters', href: '/#recruiter-workflow' },
    //{ label: 'For Candidates', href: '#candidate-experience' },
    //{ label: 'Pricing', href: '#pricing' },
   // { label: 'Resources', href: '#faq' }
  ];

  // Dynamic classes based on scroll state
  const headerBgClass = isScrolled ? 'bg-white/95 blur-backdrop shadow-elegant' : 'bg-transparent';
  const textColorClass = isScrolled ? 'text-slate-900' : 'text-white';
  const linkHoverClass = isScrolled ? 'hover:text-indigo-600' : 'hover:text-white/90';
  const iconColorClass = isScrolled ? 'text-slate-900' : 'text-white';
  const ctaClass = isScrolled
    ? 'gradient-gold text-slate-900 font-semibold px-6 py-3 rounded-lg shadow-elegant hover:shadow-lg transition-all duration-200'
    : 'bg-white/10 backdrop-blur px-6 py-3 rounded-lg text-white font-semibold border border-white/20 hover:opacity-90 transition-all duration-200';

  return (
    <motion.header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${headerBgClass}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <div className="flex items-center">
            <motion.div
              className="flex items-center space-x-2"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 400 }}
            >
              <div className={`w-8 h-8 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-lg flex items-center justify-center`}>
                <span className={`font-bold text-sm ${isScrolled ? 'text-slate-900' : 'text-white'}`}>IS</span>
              </div>
              <span className={`font-display font-bold text-xl ${textColorClass}`}>
                <a href="/">Instashortlist</a>
              </span>
            </motion.div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className={`${textColorClass} ${linkHoverClass} font-medium transition-colors duration-200`}
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center">
            <motion.button
              onClick={onBookPilot}
              className={ctaClass}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Book Free Pilot
            </motion.button>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`${iconColorClass} hover:text-indigo-500 p-2`}
            >
              <SafeIcon icon={isMobileMenuOpen ? FiX : FiMenu} className={`w-6 h-6 ${iconColorClass}`} />
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <motion.div
            className={`lg:hidden border-t border-gray-200 ${isScrolled ? 'bg-white' : 'bg-black/80'}`}
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
          >
            <div className="px-4 py-6 space-y-4">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className={`block font-medium py-2 ${isScrolled ? 'text-slate-700 hover:text-indigo-600' : 'text-white hover:text-white/90'}`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <button
                onClick={() => {
                  onBookPilot();
                  setIsMobileMenuOpen(false);
                }}
                className={`${isScrolled ? 'gradient-gold text-slate-900' : 'bg-white/10 text-white'} w-full font-semibold px-6 py-3 rounded-lg shadow-elegant mt-4`}
              >
                Book Free Pilot
              </button>
            </div>
          </motion.div>
        )}
      </nav>
    </motion.header>
  );
};

export default Navigation;